import { AxiosError, AxiosResponse } from 'axios'
import { defineActionCreators } from '../redux-hardtyped/defineActionCreators'

export const bffActionCreators = defineActionCreators('bff', {
  request: () => ({}),
  success: (response: AxiosResponse) => ({ response }),
  error: (error: AxiosError) => ({ error }),
  finish: (successful: boolean) => ({ successful }),
})
